<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">验证者指南</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">旋转机制</a></p>
          <div class="subAnchor">
            <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">命令</a></p>
            <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">创建验证器</a></p>
            <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">更新验证器</a></p>
            <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">存款</a></p>
            <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">添加股份</a></p>
            <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">提现</a></p>
            <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">奖励</a></p>
    
          </div>
        </div>
        
      </div>
      <div class="p1">验证者指南 (CLI)</div>
      <div id="box1" class="p2">验证者指南</div>
      <div class="p3">Staking是支持PoS（Proof of Stake）共识机制的重要基础模块。它根据验证者接受的委托权益证明的总量确定每个选举周期内的区块生产者集合的数量，并根据投票权动态确定区块顺序。同时，它也为分发和治理模块的委托关系和验证者信息查询提供了必要的支持。</div>
      <div class="p3">通过质押，您可以自由地创建验证人、更新验证人、将权益证明委托给受信任的验证人、取消您不再信任的验证人的委托以及将权益证明重新委托给其他验证人。</div>
      <div id="box2" class="p2">旋转机制</div>
      <div class="p3">Fax 会在每个固定的块高度间隔从每个集合中重新选举块生成节点，称为周期。出块集合是固定的，在同一周期内，集合中出块节点的身份保持不变。在同一周期的倒数第二个区块高度间隔，Staking 将轮换下一个周期的区块生成节点集。fax 数最高的前 23 个节点将成为下一个周期的出块节点，而不是集合中fax 数最高的前 23 个节点将被强制退出。fax 的个数只能是整数，轮换时比较集合支持的节点数时不考虑小数部分。Fax 会在每个固定的区块高度间隔重新选举区块生成节点，称为循环。每 276 个区块（一个周期）更换一次出块人，在一个周期的第 275 个区块选出下一个出块人。此更改在下一个循环的第一个块中生效。fax 数最高的前 23 个节点将成为下一个周期的出块节点，不在集合中fax 数最高的前 23 个节点内的节点将被强制退出。fax 的个数只能是整数，每次轮换比较集合支持的节点数时不考虑小数部分。fax 数最高的前23 个节点将成为下一个周期的出块节点，不在集合中 fax 数最高的前 23 个节点内的节点将被强制退出。fax 的个数只能是整数，每次轮换比较集合支持的节点数时不考虑小数部分。fax 数最高的前 23 个节点将成为下一个周期的出块节点，不在集合中fax数最高的前 23 个节点内的节点将被强制退出。fax 的个数只能是整数，每次轮换比较集合支持的节点数时不考虑小数部分。</div>
      <div id="box21" class="p4">命令</div>
      <div class="p3">Staking cli 命令包含以下 5 个用于 PoS 操作的命令。</div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>create-validator：创建验证器</li>
            <li>edit-validator：更新一个验证器</li>
            <li>deposit：存入代币</li>
            <li>add shares：添加以存入代币计算的股份</li>
            <li>withdraw：提现存入的代币</li>
        </ul>
      </div>
      <div id="box22" class="p4">创建验证器</div>
      <div class="p3">将节点升级为验证器并在验证器上设置描述。</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli tx staking create-validator --pubkey=$(exchaind tendermint show-validator)--min-self-delegation 1000 --moniker="my nickname"--identity="logo|||http://mywebsite/pic/logo.jpg" --website="http://mywebsite"--details="90" --from jack --gas-prices < gasPrice ></div>
        </div>
      </div>
      <div class="p3">注意：如果在执行时设置了 home flag ，home flag 后面的输入应该和.exchaind startexchaind tendermint show-validatorfaxcahind start</div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>Pubkey代表当前节点的tendermint公钥</li>
            <li>Moniker表示验证者的别名</li>
            <li>Identity 指定验证者头像的地址</li>
            <li>Website 表示验证者的网站地址</li>
            <li>Details 表示验证者的分润百分比例</li>
            <li>from 指定操作者的账号，这里是 jack</li>
            <li>min-self-delegation 最少质押数量。最少质押 1000 fax 获取出块资格，质押大于等于 500fax，小于 1000fax 没有出块资格属于 unbonded 状态验证人，质押小于 500fax 不能成为验证人</li>
            <li>gasPrice 0.00000005fax</li>
        </ul>
      </div>
      <div id="box23" class="p4">更新验证器</div>
      <div class="p3">运营商可以更新验证者的描述并调整佣金率。</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break: break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli tx staking edit-validator --moniker=“my new nickname”--identity="logo|||http://mynewwebsite/pic/newlogo.jpg" --website="http://mynewwebsite"--details="90" --from jack --gas-prices < gasPrice ></div>
        </div>
      </div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>moniker 表示要更新的验证器的别名</li>
            <li>identity 指定要更新的验证者头像的地址</li>
            <li>website 表示要更新的验证者的网址</li>
            <li>details 表示验证者的分润百分比例</li>
            <li>from 指定运营商的账号，这里是 jack</li>
            <li>gasPrice 0.00000005fax</li>
        </ul>
      </div>
      <div id="box24" class="p4">存款</div>
      <div class="p3">用户首先需要存入一定数量的 fax 才能使 Staking 账户成为委托人。</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break: break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli tx staking deposit < amountToDeposit > --from < delegatorKeyName > --gas auto--gas-adjustment 1.5 --gas-prices < gasPrice ></div>
        </div>
      </div>
      <div id="box25" class="p4">添加股份</div>
      <div class="p3">Fax 委托人可以通过以下命令向自己或其他验证人添加股份：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break: break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli tx staking add-shares fvaloper1qj5c07sm6jetjz8f509qtrxgh4psxkv3m2wy6x,fvaloper1hcngft7gfkhn8z8fnlajzh7agyt0az0vv9pllr,fvaloper1c5g4v00np7fjjnexkhh5yk0hc6mamf40u5vjrh,fvaloper1fh9tpkqka29n0mj307cu5cvp5ts0p4dl8uug6e --from < delegatorKeyName > --gas-prices < gasPrice ></div>
        </div>
      </div>
      <div class="p3">
        <ul style="padding-left:15px;word-break: break-all;">
            <li>在上面的例子中，fvaloper1qj5c07sm6jetjz8f509qtrxgh4psxkv3m2wy6x,fvaloper1hcngft7gfkhn8z8fnlajzh7agyt0az0vv9pllr,fvaloper1c5g4v00np7fjjnexkhh5yk0hc6mamf40u5vjrh,fvaloper1fh9tpkqka29n0mj307cu5cvp5ts0p4dl8uug6e 是验证人的地址，所有存入的fax 都将转换为股票并添加到上述验证人上。</li>
            <li>from 标志指定谁签署交易。</li>
            <li>gasPrice 0.00000005fax</li>
        </ul>
      </div>
      <div id="box26" class="p4">提现</div>
      <div class="p3">当 Fax 用户提取存入的代币时，添加到验证者的份额将被移除。此代币提取过程需要21天。</div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>允许提取的代币数量必须大于或等于 0.0001 ~ n（用户存入的代币总数）。</li>
            <li>如果用户在某些验证人上添加了 Staking 权限，执行该命令后，Staking 权限的数量会自动更新。本质上，这个动作可以被认为是一种 re-vote 行为。</li>
            <li>如果用户已经添加了股份，在执行撤消所有代币的命令后，可以认为是一种unbond行为。</li>
            <li>如果用户没有添加股份，则执行该命令后新的代币不会转化为股份。</li>
            <li>允许用户多次提取存入的代币。每次提取代币时，代币将被锁定21 天，然后再发送回用户的账户。如果用户在 21 天内（最后一次提币后）再次提币，最后一次提币将被锁定 21 天，并与第二批提币一起退回用户账户。</li>
            <li>从所有验证者中提取一定数量的 fax 和相应的份额。exchaincli tx staking withdraw 10fax --from rose --gas-prices < gasPrice ></li>
            <li>在示例中，10 是要提取的存入 fax 的数量。</li>
            <li>from 表示要提现的用户账户，在本例中为“rose”。</li>
            <li>gasPrice 0.00000005fax</li>
        </ul>
      </div>
      <div id="box27" class="p4">奖励</div>
      <div class="p3">验证者将因表现良好而获得奖励。所有者可以使用以下命令提取奖励：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break: break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli tx distr withdraw-rewards < validator-addr > --from < validatorKeyName > --gas auto--gas-adjustment 1.5 --gas-prices < gasPrice ></div>
        </div>
      </div>
      <div class="p3">
        <ul style="padding-left:15px">
            <li>validator-addr 验证人地址</li>
            <li>gasPrice 0.00000005fax</li>
            <li>from 表示要提现的验证人账户</li>
        </ul>
      </div>
      
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">验证者指南)</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">旋转机制</a></p>
      <div class="subAnchor">
        <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">命令</a></p>
        <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">创建验证器</a></p>
        <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">更新验证器</a></p>
        <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">存款</a></p>
        <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">添加股份</a></p>
        <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">提现</a></p>
        <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">奖励</a></p>

      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlatformTransactionFormat',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
        font-size: 15px
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>